<template>
  <ais-pagination show-previous
                  show-next
                  :show-first="false"
                  :show-last="false"
                  :padding="1"
                  class="products-listing-pagination">
    <template v-slot="{
                currentRefinement,
                nbPages,
                pages,
                isFirstPage,
                isLastPage,
                refine,
                createURL
              }">
      <ul class="products-listing-pagination__list">

        <li class="products-listing-pagination__item products-listing-pagination__item--previous-page"
            :class="{ 'products-listing-pagination__item--disabled': isFirstPage }">
          <a class="products-listing-pagination__link"
            :href="createURL(currentRefinement - 1)"
            @click.prevent="changePage(refine, currentRefinement - 1)" />
        </li>

        <template v-if="!pages.includes(0)">
          <li class="products-listing-pagination__item">
            <a class="products-listing-pagination__link"
              :href="createURL(0)"
              @click.prevent="changePage(refine, 0)">
              1
            </a>
          </li>

          <li v-if="first(pages) > 2"
              class="products-listing-pagination__item products-listing-pagination__item--ellipsis">
            ...
          </li>
          <li v-else-if="first(pages) > 1"
              class="products-listing-pagination__item">
              <a class="products-listing-pagination__link"
               :href="createURL(1)"
               @click.prevent="changePage(refine, 1)">
              2
            </a>
          </li>
        </template>

        <li v-for="page in pages"
            :key="page"
            class="products-listing-pagination__item"
            :class="{ 'products-listing-pagination__item--selected': page === currentRefinement }">
          <a class="products-listing-pagination__link"
             :href="createURL(page)"
             @click.prevent="changePage(refine, page)">
            {{ page + 1 }}
          </a>
        </li>

        <template v-if="nbPages > 0 && !pages.includes(nbPages - 1)">
          <li v-if="nbPages - 1 > last(pages) + 2"
              class="products-listing-pagination__item products-listing-pagination__item--ellipsis">
            ...
          </li>
          <li v-else-if="last(pages) + 2 <= nbPages - 1"
              class="products-listing-pagination__item">
              <a class="products-listing-pagination__link"
               :href="createURL(last(pages) + 1)"
               @click.prevent="changePage(refine, last(pages) + 1)">
              {{ last(pages) + 2 }}
            </a>
          </li>
          <li class="products-listing-pagination__item">
            <a class="products-listing-pagination__link"
               :href="createURL(nbPages)"
               @click.prevent="changePage(refine, nbPages)">
              {{ nbPages }}
            </a>
          </li>
        </template>

        <li class="products-listing-pagination__item products-listing-pagination__item--next-page"
            :class="{ 'products-listing-pagination__item--disabled': isLastPage }">
          <a class="products-listing-pagination__link"
             :href="createURL(currentRefinement + 1)"
             @click.prevent="changePage(refine, currentRefinement + 1)"/>
        </li>

      </ul>
    </template>
  </ais-pagination>
</template>

<script>
  import { AisPagination } from 'vue-instantsearch'
  import { first, last } from 'lodash'

  export default {
    components: {
      AisPagination
    },
    methods: {
      first,
      last,
      changePage (refine, page) {
        refine(page)
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '@/assets/stylesheets/variables';

  .products-listing-pagination {
    &__list {
      display: flex;
      align-items: center;
      list-style: none;
      margin: 0;
      padding: 0;
      margin-left: -20px;
    }

    &__item {
      padding: 0;
      width: 28px;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: 'OpenSans Light';
      font-size: 1.4rem;
      color: $gunmetal;

      &--disabled {
        pointer-events: none;
        opacity: .5;
      }

      &--ellipsis, &--selected {
        font-family: 'OpenSans SemiBold';
      }

      &--selected {
        border: 1px solid $dark-chestnut-brown;
        border-radius: 50%;

        .products-listing-pagination {
          &__link {
            color: $dark-chestnut-brown;
          }
        }
      }

      &--previous-page, &--next-page {
        .products-listing-pagination {
          &__link {
            color: transparent;
            user-select: none;
            position: relative;

            &::before {
              cursor: pointer;
              content: '';
              display: block;
              width: 9px;
              height: 9px;
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center;
              top: 50%;
              left: 0;
              transform: translate(-50%, -50%);
              position: absolute;
            }
          }
        }
      }

      &--previous-page {
        .products-listing-pagination {
          &__link {
            &::before {
              background-image: url('@/assets/images/pagination-arrow-left.svg');
            }
          }
        }
      }

      &--next-page {
        .products-listing-pagination {
          &__link {
            &::before {
              background-image: url('@/assets/images/pagination-arrow-right.svg');
            }
          }
        }
      }
    }
  }
</style>
